import userClient from "../../services/httpClient/userClient";
import authClient from "../../services/httpClient/authClient";
import {
  BusinessDetailPayload,
  EmploymentDetailPayload,
  EmploymentDetailResponse,
  GetUserResponse,
  ReferralCodeResponse,
  UserUpdatePayload,
  UpdateUserResponse,
  BusinessDetailsResponse,
  ProfileImage,
  ProfileImageResponse,
  IdNumberConfirmationResponse,
  OtpValidatePayload,
  ValidateOtpResponse,
  // NewProfileImageResponse,
} from "./models";

export const getReferralCode = () =>
  userClient.get<ReferralCodeResponse>("/api/User/referral-code");

export const getEmploymentDetail = () =>
  userClient.get<EmploymentDetailResponse>("/api/User/employment-details");

export const updateEmploymentDetail = (payload: EmploymentDetailPayload) =>
  userClient.put<ReferralCodeResponse>("/api/User/employment-details", payload);

export const getUser = () => userClient.get<GetUserResponse>("/api/User");

export const updateUser = (payload: UserUpdatePayload) =>
  userClient.put<UpdateUserResponse>("/api/User", payload);

export const getBusinessDetails = () =>
  userClient.get<BusinessDetailsResponse>("/api/User/business-details");

export const updateBusinessDetails = (payload: BusinessDetailPayload) =>
  userClient.put<BusinessDetailsResponse>(
    "/api/User/business-details",
    payload
  );

export const uploadProfileImage = (payload: ProfileImage) =>
  userClient.post<ProfileImageResponse>(
    "/api/User/upload-profile-image",
    payload
  );
export const getProfileImage = () =>
  userClient.get<ProfileImageResponse>("/api/User/get-profile-image");

export const confirmUserIdentity = (idNumber: string, idType: number) =>
  userClient.get<IdNumberConfirmationResponse>(
    `/api/User/identity-verification?idNumber=${idNumber}&idType=${idType}`
  );

// export const otpSend = () => userClient.post('/api/Otp/send')

export const otpValidate = async (payload: OtpValidatePayload) =>
  authClient.post("/api/Account/validate-otp", payload);



// export const setUpSecurityQuestion = async (body: any) => authClient.post(
//   '/api/Account/savesecurity-questions',
//   body
// )